import { useEffect } from 'react';
const Logout = () => {

    useEffect(() => {
        const handleRedirect = () => {
           
    
                
                const tenantId = process.env.REACT_APP_IDP_TENANT_ID;
                const baseUrl = process.env.REACT_APP_IDP_BASE_URL;
                const redirectUri = encodeURIComponent(process.env.REACT_APP_IDP_REDIRECT_URI);// Use the stored path or default to '/'
                const logoutUrl = `${baseUrl}/${tenantId}/oauth2/v2.0/logout?&post_logout_redirect_uri=${redirectUri}`;

                // Redirect to the IDP authorization URL
                window.location.href = logoutUrl;
            
        };

        handleRedirect();
    });
};

export default Logout;